/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
    if(response.status !== 204) {
        return response.json();
    } else {
        return new Promise(resolve => { resolve(response) });
    }
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
    //console.log('checkStatus', response.status);
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    const error = new Error(response.statusText);
    error.response = response;
    error.status = response.status;
    //console.log('error here', error);
    throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export function request(url, options) {
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON);
}

export function requestConfig(method, body, token) {
    let config = {
        method: method,
        headers: new Headers({
            'Accept': 'application/json'
        })
    };

    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        config.headers.append('Content-Type', 'application/json');
    }

    if(token != null) {
        config.headers.append('Authorization', `Bearer ${token}`)
    }

    if (body !== null) {
        config.body = JSON.stringify(body);
    }

    return config;
}



// WEBPACK FOOTER //
// ./src/utils/request.js